<template>
  <div class="img-outer-container">
    <a-carousel autoplay dotsClass="dot-class" v-if="images.length > 0">
      <div
        class="img-container top-img-container"
        v-for="imgSrc in images"
        :key="imgSrc"
      >
        <!-- @load="calculateImg"  -->
        <img alt="pic" :src="imgSrc" />
      </div>
    </a-carousel>
    <div v-if="loaded && images.length === 0" class="j-coming-soon j-content">
      {{ $t('common.coming_soon') }}
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'TopBannerSection',
  props: {
    images: {
      type: Array,
      required: true,
      default: () => []
    },
    loaded: {
      required: true,
      type: Boolean,
      default: false
    }
  }
  // mounted() {
  //   this.calculateImg();
  // },
  // created() {
  //   this.$bus.$on('calculate-img', this.calculateImg);
  // },
  // methods: {
  //   calculateImg() {
  //     const imgs: any[] = Array.from(
  //       document.querySelectorAll('.top-img-container')
  //     );

  //     imgs.forEach(e => {
  //       e.style.height = `${window.innerWidth / 2}px`;
  //     });
  //   }
  // }
});
</script>

<style lang="scss" scoped>
.img-outer-container {
  .img-container {
    img {
      width: 100%;
      height: 100%;
      height: calc(100vh - 80px);
    }
  }
  margin-bottom: 80px;

  ::v-deep(.dot-class) {
    &.slick-dots-bottom {
      top: calc(100% - 30px);
      bottom: auto;
    }

    li {
      margin: 0 4px;
    }

    li button {
      background: white;
      opacity: 1;
      height: 8px;
      width: 24px;
    }
    li.slick-active button {
      background: $primary-color;
      width: 32px;
    }
  }
}
</style>
